import remainingChars from "surveylabJsAssets/page/_remaining-chars";
import ratingSlider from "surveylabJsAssets/page/_rating-slider";

export default function () {
    remainingChars.initOnce();
    ratingSlider.initOnce();
    $(function () {
        $('.likert-horizontal-free').on('keyup change', function () {
            toggleRadio($(this));
        });
    });
}

function toggleRadio(textboxElement: JQuery): void {
    const containerElement = textboxElement.closest('.item-row');
    const radioContainer = containerElement.find($('.radio'));
    const radioElements = radioContainer.find($('input[type="radio"]'));
    const textboxValue = <string>textboxElement.val();
    if (textboxValue.length > 0) {
        radioElements.prop('disabled', false);
        radioContainer.removeClass('disabled');
    } else {
        radioElements.prop('disabled', true).prop('checked', false);
        radioContainer.addClass('disabled');
    }
}